Ext.ns('mx.Util');

mx.Util.Cookies = {
    cookieProvider: null,

    decodeJsonCookie: function(name) {
        var json = this.getCookieProvider().get(name);
        if (json) {
            return Ext.util.JSON.decode(json);
        }
        return null;
    },

    get: function(name) {
        return this.getCookieProvider().get(name);
    },

    set: function(key, value) {
        return this.getCookieProvider().set(key, value);
    },

    safeGet: function(name) {
        var localCookies = this.getCookieProvider().readCookies();
        return typeof localCookies[name] == 'undefined' ? null : localCookies[name];
    },

    getCookieProvider: function() {
        if (this.cookieProvider == null) {
            this.cookieProvider = new Ext.state.CookieProvider({
                path: '/',
                expires: new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000), //365 days
            });
            //Ext.state.Manager.setProvider(this.cookieProvider);
        }
        return this.cookieProvider;
    },

    getStorageProvider: function() {
        return localStorage;
    },

    decodePointsCookie: function(encodedPoints) {
        var result = [];
        if (encodedPoints && encodedPoints.length) {
            var points = encodedPoints.split('|');
            for (var i = 0; i < points.length; i = i + 1) {
                var point = points[i].split(', ');
                result.push({lat: Number(point[0]), lon: Number(point[1])});
            }
        }
        return result;
    },
};
